var _defs, _text, _text2, _text3, _text4, _text5, _text6, _text7, _text8, _text9, _text0, _text1, _text10, _text11, _text12, _text13, _text14, _text15, _text16, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _line1, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _line34, _line35, _line36, _line37, _line38, _line39, _line40, _line41, _line42, _line43, _line44, _line45, _line46, _line47, _line48, _line49, _line50, _line51, _line52, _line53, _line54, _line55, _line56, _line57, _line58, _line59, _line60, _line61, _line62, _line63, _line64, _line65, _line66, _line67, _line68, _line69, _line70, _line71, _line72, _line73, _line74, _line75, _line76, _line77, _line78, _line79, _line80, _line81, _line82, _line83, _line84, _line85, _line86, _line87, _line88, _line89, _line90, _line91, _line92, _line93, _line94, _line95, _line96, _line97, _line98, _line99, _line100, _line101, _line102, _line103, _line104, _line105, _line106, _line107, _line108, _line109, _line110, _line111, _line112, _line113, _line114, _line115, _line116, _line117, _line118, _line119, _line120, _line121, _line122, _line123, _line124, _line125, _line126, _line127, _line128, _line129, _line130, _line131, _line132, _line133, _line134, _line135, _line136, _line137, _line138, _line139, _line140, _line141, _line142, _line143, _line144, _line145, _line146, _line147, _line148, _line149, _line150, _line151, _line152, _line153, _line154, _line155, _line156, _line157, _line158, _line159, _line160, _line161, _line162, _line163, _line164, _line165, _line166, _line167, _line168, _line169, _line170, _line171, _line172, _line173, _line174, _line175, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPls1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 413.15 191.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{font-size:9px;font-family:ProximaNova-Regular, Proxima Nova;}.cls-1,.cls-8{fill:#6b7b84;}.cls-2,.cls-3,.cls-4,.cls-5,.cls-6{fill:none;stroke:#6b7b84;stroke-miterlimit:10;stroke-width:0.5px;}.cls-3{stroke-dasharray:2.02 2.02;}.cls-4{stroke-dasharray:1.98 1.98;}.cls-5{stroke-dasharray:1.98 1.98;}.cls-6{stroke-dasharray:1.98 1.98;}.cls-7{fill:#812990;}.cls-9{fill:#231f20;}"))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(341.57 189.24)"
  }, "0")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(407.64 121.47)"
  }, "0")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(408.87 92.98)"
  }, "1")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(407.75 64.49)"
  }, "2")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(407.89 35.99)"
  }, "3")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(407.89 7.5)"
  }, "4")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(314.45 189.24)"
  }, "1")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(284.99 189.24)"
  }, "2")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(256.78 189.24)"
  }, "3")), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(228.43 189.24)"
  }, "4")), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(199.94 189.24)"
  }, "5")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(171.59 189.24)"
  }, "6")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(143.58 189.24)"
  }, "7")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(114.94 189.24)"
  }, "8")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(86.55 189.24)"
  }, "9")), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(56.58 189.24)"
  }, "10")), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(29.47 189.24)"
  }, "11")), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(0 189.24)"
  }, "12")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 344.33,
    y1: 5.1,
    x2: 344.33,
    y2: 175.13
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 341.49,
    y1: 118.44,
    x2: 341.49,
    y2: 146.78
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 338.66,
    y1: 118.44,
    x2: 338.66,
    y2: 146.78
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 335.82,
    y1: 118.44,
    x2: 335.82,
    y2: 146.78
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 332.99,
    y1: 118.44,
    x2: 332.99,
    y2: 146.78
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 330.15,
    y1: 118.44,
    x2: 330.15,
    y2: 160.96
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 327.32,
    y1: 118.44,
    x2: 327.32,
    y2: 146.78
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 324.48,
    y1: 118.44,
    x2: 324.48,
    y2: 146.78
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 321.65,
    y1: 118.44,
    x2: 321.65,
    y2: 146.78
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 318.81,
    y1: 118.44,
    x2: 318.81,
    y2: 146.78
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 315.98,
    y1: 118.44,
    x2: 315.98,
    y2: 175.13
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 313.14,
    y1: 118.44,
    x2: 313.14,
    y2: 146.78
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 310.31,
    y1: 118.44,
    x2: 310.31,
    y2: 146.78
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 307.48,
    y1: 118.44,
    x2: 307.48,
    y2: 146.78
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 304.64,
    y1: 118.44,
    x2: 304.64,
    y2: 146.78
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 301.81,
    y1: 118.44,
    x2: 301.81,
    y2: 160.96
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 298.97,
    y1: 118.44,
    x2: 298.97,
    y2: 146.78
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 296.14,
    y1: 118.44,
    x2: 296.14,
    y2: 146.78
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 293.3,
    y1: 118.44,
    x2: 293.3,
    y2: 146.78
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 290.47,
    y1: 118.44,
    x2: 290.47,
    y2: 146.78
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 287.63,
    y1: 118.44,
    x2: 287.63,
    y2: 175.13
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 284.8,
    y1: 118.44,
    x2: 284.8,
    y2: 146.78
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 281.96,
    y1: 118.44,
    x2: 281.96,
    y2: 146.78
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 279.13,
    y1: 118.44,
    x2: 279.13,
    y2: 146.78
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 276.29,
    y1: 118.44,
    x2: 276.29,
    y2: 146.78
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 273.46,
    y1: 118.44,
    x2: 273.46,
    y2: 160.96
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 270.63,
    y1: 118.44,
    x2: 270.63,
    y2: 146.78
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 267.79,
    y1: 118.44,
    x2: 267.79,
    y2: 146.78
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 264.96,
    y1: 118.44,
    x2: 264.96,
    y2: 146.78
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 262.12,
    y1: 118.44,
    x2: 262.12,
    y2: 146.78
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 259.29,
    y1: 118.44,
    x2: 259.29,
    y2: 175.13
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 256.45,
    y1: 118.44,
    x2: 256.45,
    y2: 146.78
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 253.62,
    y1: 118.44,
    x2: 253.62,
    y2: 146.78
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 250.78,
    y1: 118.44,
    x2: 250.78,
    y2: 146.78
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 247.95,
    y1: 118.44,
    x2: 247.95,
    y2: 146.78
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 245.11,
    y1: 118.44,
    x2: 245.11,
    y2: 160.96
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 242.28,
    y1: 118.44,
    x2: 242.28,
    y2: 146.78
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 239.44,
    y1: 118.44,
    x2: 239.44,
    y2: 146.78
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 236.61,
    y1: 118.44,
    x2: 236.61,
    y2: 146.78
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 233.77,
    y1: 118.44,
    x2: 233.77,
    y2: 146.78
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 230.94,
    y1: 118.44,
    x2: 230.94,
    y2: 175.13
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 228.11,
    y1: 118.44,
    x2: 228.11,
    y2: 146.78
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 225.27,
    y1: 118.44,
    x2: 225.27,
    y2: 146.78
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 222.44,
    y1: 118.44,
    x2: 222.44,
    y2: 146.78
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 219.6,
    y1: 118.44,
    x2: 219.6,
    y2: 146.78
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 216.77,
    y1: 118.44,
    x2: 216.77,
    y2: 160.96
  })), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 213.93,
    y1: 118.44,
    x2: 213.93,
    y2: 146.78
  })), _line46 || (_line46 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 211.1,
    y1: 118.44,
    x2: 211.1,
    y2: 146.78
  })), _line47 || (_line47 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 208.26,
    y1: 118.44,
    x2: 208.26,
    y2: 146.78
  })), _line48 || (_line48 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 205.43,
    y1: 118.44,
    x2: 205.43,
    y2: 146.78
  })), _line49 || (_line49 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 202.59,
    y1: 118.44,
    x2: 202.59,
    y2: 175.13
  })), _line50 || (_line50 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 199.76,
    y1: 118.44,
    x2: 199.76,
    y2: 146.78
  })), _line51 || (_line51 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 196.92,
    y1: 118.44,
    x2: 196.92,
    y2: 146.78
  })), _line52 || (_line52 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 194.09,
    y1: 118.44,
    x2: 194.09,
    y2: 146.78
  })), _line53 || (_line53 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 191.26,
    y1: 118.44,
    x2: 191.26,
    y2: 146.78
  })), _line54 || (_line54 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 188.42,
    y1: 118.44,
    x2: 188.42,
    y2: 160.96
  })), _line55 || (_line55 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 185.59,
    y1: 118.44,
    x2: 185.59,
    y2: 146.78
  })), _line56 || (_line56 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 182.75,
    y1: 118.44,
    x2: 182.75,
    y2: 146.78
  })), _line57 || (_line57 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 179.92,
    y1: 118.44,
    x2: 179.92,
    y2: 146.78
  })), _line58 || (_line58 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 177.08,
    y1: 118.44,
    x2: 177.08,
    y2: 146.78
  })), _line59 || (_line59 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 174.25,
    y1: 118.44,
    x2: 174.25,
    y2: 175.13
  })), _line60 || (_line60 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 171.41,
    y1: 118.44,
    x2: 171.41,
    y2: 146.78
  })), _line61 || (_line61 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 168.58,
    y1: 118.44,
    x2: 168.58,
    y2: 146.78
  })), _line62 || (_line62 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 165.74,
    y1: 118.44,
    x2: 165.74,
    y2: 146.78
  })), _line63 || (_line63 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 162.91,
    y1: 118.44,
    x2: 162.91,
    y2: 146.78
  })), _line64 || (_line64 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 160.07,
    y1: 118.44,
    x2: 160.07,
    y2: 160.96
  })), _line65 || (_line65 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 157.24,
    y1: 118.44,
    x2: 157.24,
    y2: 146.78
  })), _line66 || (_line66 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 154.4,
    y1: 118.44,
    x2: 154.4,
    y2: 146.78
  })), _line67 || (_line67 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 151.57,
    y1: 118.44,
    x2: 151.57,
    y2: 146.78
  })), _line68 || (_line68 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 148.74,
    y1: 118.44,
    x2: 148.74,
    y2: 146.78
  })), _line69 || (_line69 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 145.9,
    y1: 118.44,
    x2: 145.9,
    y2: 175.13
  })), _line70 || (_line70 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 143.07,
    y1: 118.44,
    x2: 143.07,
    y2: 146.78
  })), _line71 || (_line71 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 140.23,
    y1: 118.44,
    x2: 140.23,
    y2: 146.78
  })), _line72 || (_line72 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 137.4,
    y1: 118.44,
    x2: 137.4,
    y2: 146.78
  })), _line73 || (_line73 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 134.56,
    y1: 118.44,
    x2: 134.56,
    y2: 146.78
  })), _line74 || (_line74 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 131.73,
    y1: 118.44,
    x2: 131.73,
    y2: 160.96
  })), _line75 || (_line75 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 128.89,
    y1: 118.44,
    x2: 128.89,
    y2: 146.78
  })), _line76 || (_line76 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 126.06,
    y1: 118.44,
    x2: 126.06,
    y2: 146.78
  })), _line77 || (_line77 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 123.22,
    y1: 118.44,
    x2: 123.22,
    y2: 146.78
  })), _line78 || (_line78 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 120.39,
    y1: 118.44,
    x2: 120.39,
    y2: 146.78
  })), _line79 || (_line79 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 117.55,
    y1: 118.44,
    x2: 117.55,
    y2: 175.13
  })), _line80 || (_line80 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 114.72,
    y1: 118.44,
    x2: 114.72,
    y2: 146.78
  })), _line81 || (_line81 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 111.89,
    y1: 118.44,
    x2: 111.89,
    y2: 146.78
  })), _line82 || (_line82 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 109.05,
    y1: 118.44,
    x2: 109.05,
    y2: 146.78
  })), _line83 || (_line83 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 106.22,
    y1: 118.44,
    x2: 106.22,
    y2: 146.78
  })), _line84 || (_line84 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 103.38,
    y1: 118.44,
    x2: 103.38,
    y2: 160.96
  })), _line85 || (_line85 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 100.55,
    y1: 118.44,
    x2: 100.55,
    y2: 146.78
  })), _line86 || (_line86 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 97.71,
    y1: 118.44,
    x2: 97.71,
    y2: 146.78
  })), _line87 || (_line87 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 94.88,
    y1: 118.44,
    x2: 94.88,
    y2: 146.78
  })), _line88 || (_line88 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 92.04,
    y1: 118.44,
    x2: 92.04,
    y2: 146.78
  })), _line89 || (_line89 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 89.21,
    y1: 118.44,
    x2: 89.21,
    y2: 175.13
  })), _line90 || (_line90 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 86.37,
    y1: 118.44,
    x2: 86.37,
    y2: 146.78
  })), _line91 || (_line91 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 83.54,
    y1: 118.44,
    x2: 83.54,
    y2: 146.78
  })), _line92 || (_line92 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 80.7,
    y1: 118.44,
    x2: 80.7,
    y2: 146.78
  })), _line93 || (_line93 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 77.87,
    y1: 118.44,
    x2: 77.87,
    y2: 146.78
  })), _line94 || (_line94 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 75.03,
    y1: 118.44,
    x2: 75.03,
    y2: 160.96
  })), _line95 || (_line95 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 72.2,
    y1: 118.44,
    x2: 72.2,
    y2: 146.78
  })), _line96 || (_line96 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 69.37,
    y1: 118.44,
    x2: 69.37,
    y2: 146.78
  })), _line97 || (_line97 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 66.53,
    y1: 118.44,
    x2: 66.53,
    y2: 146.78
  })), _line98 || (_line98 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 63.7,
    y1: 118.44,
    x2: 63.7,
    y2: 146.78
  })), _line99 || (_line99 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 60.86,
    y1: 118.44,
    x2: 60.86,
    y2: 175.13
  })), _line100 || (_line100 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 58.03,
    y1: 118.44,
    x2: 58.03,
    y2: 146.78
  })), _line101 || (_line101 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 55.19,
    y1: 118.44,
    x2: 55.19,
    y2: 146.78
  })), _line102 || (_line102 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 52.36,
    y1: 118.44,
    x2: 52.36,
    y2: 146.78
  })), _line103 || (_line103 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 49.52,
    y1: 118.44,
    x2: 49.52,
    y2: 146.78
  })), _line104 || (_line104 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 46.69,
    y1: 118.44,
    x2: 46.69,
    y2: 160.96
  })), _line105 || (_line105 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 43.85,
    y1: 118.44,
    x2: 43.85,
    y2: 146.78
  })), _line106 || (_line106 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 41.02,
    y1: 118.44,
    x2: 41.02,
    y2: 146.78
  })), _line107 || (_line107 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 38.18,
    y1: 118.44,
    x2: 38.18,
    y2: 146.78
  })), _line108 || (_line108 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 35.35,
    y1: 118.44,
    x2: 35.35,
    y2: 146.78
  })), _line109 || (_line109 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 32.52,
    y1: 118.44,
    x2: 32.52,
    y2: 175.13
  })), _line110 || (_line110 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 29.68,
    y1: 118.44,
    x2: 29.68,
    y2: 146.78
  })), _line111 || (_line111 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 26.85,
    y1: 118.44,
    x2: 26.85,
    y2: 146.78
  })), _line112 || (_line112 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 24.01,
    y1: 118.44,
    x2: 24.01,
    y2: 146.78
  })), _line113 || (_line113 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 21.18,
    y1: 118.44,
    x2: 21.18,
    y2: 146.78
  })), _line114 || (_line114 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 18.34,
    y1: 118.44,
    x2: 18.34,
    y2: 160.96
  })), _line115 || (_line115 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 15.51,
    y1: 118.44,
    x2: 15.51,
    y2: 146.78
  })), _line116 || (_line116 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 12.67,
    y1: 118.44,
    x2: 12.67,
    y2: 146.78
  })), _line117 || (_line117 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 9.84,
    y1: 118.44,
    x2: 9.84,
    y2: 146.78
  })), _line118 || (_line118 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 7,
    y1: 118.44,
    x2: 7,
    y2: 146.78
  })), _line119 || (_line119 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 4.17,
    y1: 5.1,
    x2: 4.17,
    y2: 175.13
  })), _line120 || (_line120 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 145.9,
    y1: 5.1,
    x2: 145.9,
    y2: 6.1
  })), _line121 || (_line121 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 145.9,
    y1: 8.13,
    x2: 145.9,
    y2: 116.43
  })), _line122 || (_line122 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 145.9,
    y1: 117.44,
    x2: 145.9,
    y2: 118.44
  })), _line123 || (_line123 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 4.17,
    y1: 5.1,
    x2: 401.02,
    y2: 5.1
  })), _line124 || (_line124 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 344.33,
    y1: 7.94,
    x2: 372.67,
    y2: 7.94
  })), _line125 || (_line125 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 344.33,
    y1: 10.77,
    x2: 372.67,
    y2: 10.77
  })), _line126 || (_line126 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 344.33,
    y1: 13.61,
    x2: 372.67,
    y2: 13.61
  })), _line127 || (_line127 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 344.33,
    y1: 16.44,
    x2: 372.67,
    y2: 16.44
  })), _line128 || (_line128 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 344.33,
    y1: 19.28,
    x2: 386.85,
    y2: 19.28
  })), _line129 || (_line129 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 344.33,
    y1: 22.11,
    x2: 372.67,
    y2: 22.11
  })), _line130 || (_line130 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 344.33,
    y1: 24.95,
    x2: 372.67,
    y2: 24.95
  })), _line131 || (_line131 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 344.33,
    y1: 27.78,
    x2: 372.67,
    y2: 27.78
  })), _line132 || (_line132 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 344.33,
    y1: 30.62,
    x2: 372.67,
    y2: 30.62
  })), _line133 || (_line133 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 344.33,
    y1: 33.45,
    x2: 401.02,
    y2: 33.45
  })), _line134 || (_line134 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 344.33,
    y1: 36.29,
    x2: 372.67,
    y2: 36.29
  })), _line135 || (_line135 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 344.33,
    y1: 39.12,
    x2: 372.67,
    y2: 39.12
  })), _line136 || (_line136 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 344.33,
    y1: 41.95,
    x2: 372.67,
    y2: 41.95
  })), _line137 || (_line137 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 344.33,
    y1: 44.79,
    x2: 372.67,
    y2: 44.79
  })), _line138 || (_line138 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 344.33,
    y1: 47.62,
    x2: 386.85,
    y2: 47.62
  })), _line139 || (_line139 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 344.33,
    y1: 50.46,
    x2: 372.67,
    y2: 50.46
  })), _line140 || (_line140 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 344.33,
    y1: 53.29,
    x2: 372.67,
    y2: 53.29
  })), _line141 || (_line141 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 344.33,
    y1: 56.13,
    x2: 372.67,
    y2: 56.13
  })), _line142 || (_line142 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 344.33,
    y1: 58.96,
    x2: 372.67,
    y2: 58.96
  })), _line143 || (_line143 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 344.33,
    y1: 61.8,
    x2: 401.02,
    y2: 61.8
  })), _line144 || (_line144 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 344.33,
    y1: 64.63,
    x2: 372.67,
    y2: 64.63
  })), _line145 || (_line145 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 344.33,
    y1: 67.47,
    x2: 372.67,
    y2: 67.47
  })), _line146 || (_line146 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 344.33,
    y1: 70.3,
    x2: 372.67,
    y2: 70.3
  })), _line147 || (_line147 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 344.33,
    y1: 73.14,
    x2: 372.67,
    y2: 73.14
  })), _line148 || (_line148 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 344.33,
    y1: 75.97,
    x2: 386.85,
    y2: 75.97
  })), _line149 || (_line149 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 344.33,
    y1: 78.8,
    x2: 372.67,
    y2: 78.8
  })), _line150 || (_line150 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 344.33,
    y1: 81.64,
    x2: 372.67,
    y2: 81.64
  })), _line151 || (_line151 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 344.33,
    y1: 84.47,
    x2: 372.67,
    y2: 84.47
  })), _line152 || (_line152 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 344.33,
    y1: 87.31,
    x2: 372.67,
    y2: 87.31
  })), _line153 || (_line153 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 344.33,
    y1: 90.14,
    x2: 401.02,
    y2: 90.14
  })), _line154 || (_line154 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 344.33,
    y1: 92.98,
    x2: 372.67,
    y2: 92.98
  })), _line155 || (_line155 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 344.33,
    y1: 95.81,
    x2: 372.67,
    y2: 95.81
  })), _line156 || (_line156 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 344.33,
    y1: 98.65,
    x2: 372.67,
    y2: 98.65
  })), _line157 || (_line157 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 344.33,
    y1: 101.48,
    x2: 372.67,
    y2: 101.48
  })), _line158 || (_line158 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 344.33,
    y1: 104.32,
    x2: 386.85,
    y2: 104.32
  })), _line159 || (_line159 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 344.33,
    y1: 107.15,
    x2: 372.67,
    y2: 107.15
  })), _line160 || (_line160 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 344.33,
    y1: 109.99,
    x2: 372.67,
    y2: 109.99
  })), _line161 || (_line161 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 344.33,
    y1: 112.82,
    x2: 372.67,
    y2: 112.82
  })), _line162 || (_line162 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 344.33,
    y1: 115.66,
    x2: 372.67,
    y2: 115.66
  })), _line163 || (_line163 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 4.17,
    y1: 118.49,
    x2: 401.02,
    y2: 118.49
  })), _line164 || (_line164 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 145.9,
    y1: 10.77,
    x2: 146.9,
    y2: 10.77
  })), _line165 || (_line165 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 148.89,
    y1: 10.77,
    x2: 342.33,
    y2: 10.77
  })), _line166 || (_line166 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 343.33,
    y1: 10.77,
    x2: 344.33,
    y2: 10.77
  })), _line167 || (_line167 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 145.9,
    y1: 16.44,
    x2: 146.9,
    y2: 16.44
  })), _line168 || (_line168 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 148.89,
    y1: 16.44,
    x2: 342.33,
    y2: 16.44
  })), _line169 || (_line169 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 343.33,
    y1: 16.44,
    x2: 344.33,
    y2: 16.44
  })), _line170 || (_line170 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 145.9,
    y1: 70.3,
    x2: 146.9,
    y2: 70.3
  })), _line171 || (_line171 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 148.88,
    y1: 70.3,
    x2: 342.21,
    y2: 70.3
  })), _line172 || (_line172 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 343.2,
    y1: 70.3,
    x2: 344.2,
    y2: 70.3
  })), _line173 || (_line173 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 146.01,
    y1: 87.31,
    x2: 147.01,
    y2: 87.31
  })), _line174 || (_line174 = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 149,
    y1: 87.31,
    x2: 342.16,
    y2: 87.31
  })), _line175 || (_line175 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 343.16,
    y1: 87.31,
    x2: 344.16,
    y2: 87.31
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M104.76,109l-2.76.39a9.09,9.09,0,0,1-1.36.31c-1.06-.07-1.61-1.33-3.09-1.63-.36-.06,0,.06-.55-.19-.72-.3.19-.09-.69-.33,0,1-.22.7-.22,1.45a5.64,5.64,0,0,0,.61,2.51c.27.54.39.36.36,1.14,0,1.48-.21,1.91.43,3.14a8.15,8.15,0,0,1,1.09,2.24c1.45,0,1.24-.06,1.42.42,1.37,0,.49-.3,1.24-.42.07,0,1.4.33,1-1.42,1,.27.55.81,1.22.75s.27-.51.36-1.14-.27-.18.7-.64l-.22-1.24c0-1.45.34,0,.82.22l.61-4.35c.06-.33.45-.18-.4-1.42C104.43,109,105,109,104.76,109Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M105.15,105.36c-.15.57.34.33-.39.39l.82,1.84c.36-.18.24-.15.81-.18,0-1.27,0-.81-.42-1.45C105.7,105.6,105.7,105.48,105.15,105.36Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M94.85,103.7c-.21.84-.06,0-.27.66-.33,1-.36,1.84.88,1.18C95.46,104.09,95.61,104.21,94.85,103.7Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M79,89.12a7.6,7.6,0,0,0-2.51.39c-1.52.39-.85.72-.37,1.45,2.88,0,1.94-.24,3.58-.51.66-.13.73.09.33-.73H79Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M120.69,79c0-.23-.12-.47-.19-.69l-2.35-.87c-1.68-.63-3.35-1.25-5-1.9-1.45-.59-3.36-1.38-5.24-2.32s-4-2-6.08-3.3a13.83,13.83,0,0,1-5-5.67,17.2,17.2,0,0,1-1.12-2.86h-.4a10.26,10.26,0,0,0-2.26.3c-.72.16-1.43.35-2.14.54a27.52,27.52,0,0,1-5.75,1.09l-.75,0c-.72,0-1.45.09-2.17.09s-1.13,0-1.64-.08a34.71,34.71,0,0,1-3.45-.63L76,62.48c-.3.37-.61.74-.93,1.1a3.47,3.47,0,0,1,.63.58,4.16,4.16,0,0,1,.86,4,6.2,6.2,0,0,1-5.38,4c-.68,0-1.32,0-2-.09h-.33a6.62,6.62,0,0,1-5.3-3.47,4.68,4.68,0,0,1,.38-5.16l.11-.16c.27-.43.56-.86.85-1.28a13.4,13.4,0,0,0,1-1.51c.18-.36.36-.72.53-1.09a7.07,7.07,0,0,1-5.94-4.48,14.71,14.71,0,0,1-.9-4.3l-.6.16L58,51a8.35,8.35,0,0,1-.82.89,5.2,5.2,0,0,1-3.66,1.72,4.68,4.68,0,0,1-1.45-.24h-.23a4.72,4.72,0,0,1-2.73-.85,3.5,3.5,0,0,1-1.55-1.07,3.59,3.59,0,0,1-.69-3.07,12.86,12.86,0,0,1,2.36-5.1c.11-.16.22-.3.28-.4A4.82,4.82,0,0,1,50.94,40c.63-.63,1.26-1.16,1.87-1.68l.5-.43c.29-.24.63-.53,1-.81a6.38,6.38,0,0,1,1-2.74,11.54,11.54,0,0,1,3.4-3.3c.71-.46,1.42-.85,2.1-1.23.4-.22.72-.39,1-.58s.64-.38,1-.58l.55-.34A3.07,3.07,0,0,1,65,27.83a3.17,3.17,0,0,1,1.32.29,3.24,3.24,0,0,1,1.78,3.72s-.78,2.72-1,3.6a8.44,8.44,0,0,1-1.51,2.85c.66.42,1.45.93,2.22,1.52a14.83,14.83,0,0,1,1.76,1.65h1.33a2.91,2.91,0,0,0,.47-.08,11.94,11.94,0,0,0,3.26-1.49l.46-.27a27.73,27.73,0,0,1,6.41-3.06A43.44,43.44,0,0,1,92.87,35l1.49,0c2.12,0,4.23.11,6.19.22a35.23,35.23,0,0,1,4.73.64,27.61,27.61,0,0,1,11.38,4.94,2.09,2.09,0,0,0-1.12-1.58c-.6-.28-.3.06-.73-.37,0,0-.06-.06-.09-.09l-.45-.36c-.73-.45-.61.12-.88-1l-.27.15a.43.43,0,0,0-.12.06c-.46.12-.31-.82-.73-1.33s.18.39-.88-.15c-.57-.27,0,0-.33-.24a.87.87,0,0,0-.43-.22l-.36-.09c-1.7-.69-1.39-1-1.39-2.68-1.46-.4-.58-1.51-.49-2.45.18-1.51-.72-1.69-.36-3.32-2,0-1.21-2-1.79-4.2l-.09-2c.09-.42,0,.18.24-.57l-.54-.27c-1.94-1.15-1.55-2.06-2.12-2.42l-1.43.45c-.42.31,0,.22-.63.37-1.36-1.27-.73-3.93-1.18-5.62-.18-.72-.34-1.72-1.3-2a3.19,3.19,0,0,1,.6-1.24c-.48-.24-.73-.18-1.21-.42a5.87,5.87,0,0,0-.64-3.29c-.39-.66-.12-.73-1-.82-.24,1-.15.4-1,.82a5.84,5.84,0,0,1-.75,3.17s-.06.09-.06.12l-.19.24a4.09,4.09,0,0,0-.84,2h.6c-.06.94-.06.4-.45,1-.55.81-.25-.06-.12,1s-.73,1.14-.64,2.29c.06.76.33.51.3,1.24,0,.42-.21.6-.18,1.18.06,1.54.64,1.14-.06,2.62s-.45,3-1.39,4.56A19,19,0,0,0,91,27.59a3,3,0,0,1-2.34.91,9.14,9.14,0,0,1-2.08-1c-.4-.21-.7-.33-.88-.72s-.06-.27-.25-.6c-.48-1-1.84-.94-2.81-1.3S81.34,23.1,79,22.16l-1.24-.39s-.91-.61-1-.67L76,20.23c-.24-.21-.66-.45-1-.7L74.14,19c-.82-.45-.7,0-.73-1.15.45-.15,1-1,1.36-1.54.24-.3.06,0,.24-.36l.19-.45s0-.09.06-.12c.12-.3.3-.76.42-1-.85-.33,0,.15-.82-.21.34-.48.25-.21.43-.81,1.06-.52.79-.22,1.42,0,1.24-1.82.52-.67.79-1.73.24-.87.85-1.08,1.27-1.75L78,9.36c-.84-.45-.66.33-.66-1.18a4,4,0,0,0-1.67,1.24c-.21-.27-.21.42-.21-.6a3.3,3.3,0,0,1-1,.39c.6-.79.33,0,.64-.82-1.4.34-1.91.37-2.7,1-.52-.36-.82-.33-1-1-1,.09-.27.16-1.21.43A4.71,4.71,0,0,0,68.47,8V7.58c-1.09.09-1.82.69-2.75-.36-.06-.06-.46-.76-.55-.88-.76.21-.42.21-1,.61a1.57,1.57,0,0,0-.91-1.15c-.33-.21-.09-.09-.42-.15l-1.15.09c-.15.06.3.09-.61.18v.63c.79.18.06,0,.58.24.06,0,.09.07.15.1s.06.06.12.06c.61.27.67,0,1.63,0a4.42,4.42,0,0,1,.4,1.87l-1.52.51a.23.23,0,0,1-.12.06l-1.84.21c-.79-.09-.52-.18-.82-.78-.15.06-.37.18-.55.27l-.51.3c-.61.45.3.18-.7.54a1.82,1.82,0,0,1-.94.09c0,.55,0,.52-.45,1.18s0,.61-1,.7c0,1.48.15.63.42,1.63l-.66.24c-1,.24-.55.24-.91,1.27s-.88.3-1.31,2.2c.67.45.82.45.94.87a1.68,1.68,0,0,1,.09.76c-2-.15-1.09.12-1.81-.06a7.7,7.7,0,0,0-2.3-.36c0,1.51-.07.48-.43.87l-.09.09-.3.49c0-1.42.3-.43.39-1.63-1.73-.49-1.66-2.33-3.42-2.63-1.42-.27,0-.42-1.52-.45-.36.75-.15.9-.81,1.42.21-1,.12-.31,0-.61-.76.18-.46.21-1,.61-.12-.94-.25-.79-1-.4.15.61,0,.43.6.61a2.39,2.39,0,0,0-.42,1.23l-1.21-1c-.55,1,.12.69-.79,1.27l-.27.15a6,6,0,0,0-.61.42c.3,1.12.55.21.21,1-.69.09-.75.3-1.24.93,0,0-.06.06-.09.06a1,1,0,0,1-.15.18c-.09.09-.24.21-.33.31-.31.27-.67.39-.76,1a1.83,1.83,0,0,0,.51,1.18c-.45.54-.39.36-.42,1.24l-.91-.3c-.94-.22-.45.51-.73-.31h-1c0,1.39-.51,1.06-.21,1.66.21.4.76.52,1.24,1.21-.51.21-.18.15-.81,0,.09,1.09.24.36,0,1.45-.64-.45-.31-.33-1-1.66s-.76-.45-.64-1.84c-.85.24-.79.66-1.21,1.24l-1,1.05A3.71,3.71,0,0,0,29.58,29c0,.61.36.94.36,2,.14.07.1.12.07.13a5,5,0,0,1,.54-.13c-.12.45,0,.24-.3.54l-.18.21c-.31.33-.13.12-.34.3l-.33.27-.12.09-.24.19c-.52.42-.4.48-.64,1l-.09.27c-1.24,3.26-2,3.26-5.67,4.65-.69.24,0,.15-.75.21-1,.09-.55-.48-1.4.09s-.15.49-.81,1c-1,.82-1.19-.33-3.12,1.63a1.7,1.7,0,0,1-1.28.51c-1.06,0-.27-.6-1.63.31-.09-1.09.21-.4-.39-.64-.19.67-.16.54-.7,1-1.24.93-.24-.27-2,1.69l-.21.21-.64.78s-.12.19-.18.25c-1,1.08-3.06.63-3.06,3.92H5.83a14.52,14.52,0,0,1-.21-2.26c-1.06.69-1.42,2.47-1.45,3.68.66.24.18-.33.54.51A2.82,2.82,0,0,1,4.56,54a3.26,3.26,0,0,0-.39,1.12v1.47c.06.49.18.34.66.91.58.75.16.75,1.06,1.81l.13.09c.24.3.27.39.51.73.82,1.05,1.15.51,1.15,3H7.26A3.32,3.32,0,0,0,5,60.35c0,1.9.51.63.63,2-.48-.3-.21-.24-.82-.39-.09,1.05.19.36-.42.6,1.33,2,3.42,2.75,3.94,5.31.21,1.15,1.42,1.76,1.85,2.72.24.55-.1.12.33.67.21.24.39.36.63.6a2.86,2.86,0,0,1,.7,1.78c.7,4.35,3.33,5.25,3.61,7.85l0,1.54c-.16.91.12.75.33,1.66s-.12,1.21-.3,1.9a4.61,4.61,0,0,1-1.21-.18c0,1.48-.07,2.84,1.27,2.81,1.72,0,2.33,2.11,5.18,1.63.88-.15,2.36.06,3.15-.39s.91-1,1.21-1.3l.09-.09.3-.33.18-.22.61-.36c.48-.06,1.24,0,1.45-.72,0,0,0-.34,0-.4.31-1.14,1.94-1.11,3-1.47l2.36-.34c.19,0,.25,0,.49,0,.76-.06-.21-.12.54-.12l.31.09s.06,0,.09.06c.73.34-.55.19.76.28.18-.46.42-.7,1.72-.67.88,0,2.39.64,3.06-2.14a2,2,0,0,1,.39-1.06c.52-.6.85-.33,1.67-.81,3.27-1.91,2-2.24,5.73-2.3a10.73,10.73,0,0,0,3.93-1.21c2.43-1,2.18-1.66,5.94-1.66a9.47,9.47,0,0,0,2.36-.33c.91-.15,2.73,1.3,3.42,1.75,1.19-.3.55-.84,2,.06.88.52,1.49.34,2.52.58.27.63.09,0,0,1,.66-.15.66-.27,1.24,0-.18.46-.39.31-.52.76l.43,1.18c.51.45.91,0,1.42.63s.34.87,1.09,1.81a3.31,3.31,0,0,1,.67,2s-.09,0-.09,0-.09,0-.09,0l-.12,0-.52.55c1.24.12.91.9,2,1.17a1.14,1.14,0,0,1,.43.09s.06.1.42.19l-.15-.82c-.15-.63.09-.81,1.21-2.23.76-1,2.18-1,2.75-2a5.6,5.6,0,0,1,.91-1.54c.52-.54.16.22.46-.57l.09.09.18.24a3,3,0,0,1,.33.49c-.6.06-.51.09-.81.39.42.93.45.81,0,1.39a4.82,4.82,0,0,0-1,3.23c0,1.2-.28.93-1.43.93-.18.76-.33.58-.42,1.45A4.59,4.59,0,0,0,78,87.88c.88-.21,1,.48,1.46-.6l.81-2.48.4.63c0,.06,0,.12.06.16l.15.27a.23.23,0,0,1,.06.12c1.15,2.32-.76,2.38-.88,3.74a6.78,6.78,0,0,0,2.06-.39s.09,0,.12.09.09.06.12.09C83.59,90.6,85,92,84.37,93.89c0,0,0,.09,0,.12l-.06,1a3.36,3.36,0,0,0,.88,1.3L86,97.72c.64.69,1.57.39,2.3,1.21l.58.66c.6-.21.6-.45,1.24-.27l.45.18c.06,0,.12,0,.18.06.55.15.28,0,.79.24s2.09,1.18,2.27,1.63c1.15-.09,3.37-2.92,3.91-.81,1-.09,1.06-.73,1.88-.82l-.15.28c-.27.6-.15-.37-.27.75l1,.88.31.3.63.24a1.59,1.59,0,0,1,.37.84,1,1,0,0,0,.6-1.45c2.43,0,3.12-2.41,5.7-2.32,1.66.09,3,.57,4.18-.39l.42-.58c.3-.72,0-.9.12-1.53l1.09-3a4,4,0,0,1,2.18-2.66c.61-.51.15-.15.21-.54v-.15l.13-.55a4.14,4.14,0,0,1,1.12-2c1.21-1,.69-1.69,2.51-3.65l1.18-.67c.06,0,.09-.06.15-.06l.42-.31C121.22,81.86,121,80.43,120.69,79Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M30,31.11s0,0,0,0Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M68,44.31a22.22,22.22,0,0,0-2.08-2.05,33.06,33.06,0,0,0-3.17-2.06,6.15,6.15,0,0,0-1.61-.61,2.54,2.54,0,0,0-1,0,6.78,6.78,0,0,1,1.71-2,6.1,6.1,0,0,0,2.27-3c.35-1.19.69-2.38,1-3.58L65,30.93c-.53.32-1.05.66-1.58,1-1,.58-2,1.1-3,1.72A8.41,8.41,0,0,0,57.93,36a3.53,3.53,0,0,0-.48,2.5c0,.61-.29.61-.29.61a4.27,4.27,0,0,0-1.82,1.09c-.74.63-1.51,1.25-2.2,1.94a1.9,1.9,0,0,0-.55,1.11,3.38,3.38,0,0,1-.85,1.84A10,10,0,0,0,49.91,49c-.1.49.12.68.66.59a1.48,1.48,0,0,0,1.66.63c.08,0,.18-.07.23,0,1.07.53,1.57.43,2.56-.52a5.66,5.66,0,0,0,.69-.79c.5-.74,1.31-.81,2.06-1a6.08,6.08,0,0,0,2.54-1s.56-.48.82-.13a6.53,6.53,0,0,1,1,1.33A5.88,5.88,0,0,1,62.61,50a12.36,12.36,0,0,0,.73,3.76A4,4,0,0,0,68,56.25a7.7,7.7,0,0,1,4.07.06c.26.09.5.21.8.34l-1.53-.14c-.26,0-.39,0-.51.33-.72,1.69-1.41,3.4-2.24,5-.54,1.06-1.32,2-2,3-.38.63-.93,1.33-.48,2A3.62,3.62,0,0,0,69,69c.69,0,1.39.09,2.09.09a3.24,3.24,0,0,0,2.43-1.78,1.15,1.15,0,0,0-.31-1.16,1,1,0,0,1-1.06.65,2.25,2.25,0,0,0-.68.3c0-.46.44-.45.82-.58l-.12-.89c-.14.08-.2.1-.24.15a1,1,0,0,1-1.37.46L70,66c-.61-.19-.71-.12-.77.48,0,.12,0,.25,0,.46a1.25,1.25,0,0,1,.13-1.62c.76-1,1.54-1.91,2.39-2.79a32,32,0,0,0,4.84-6.45A3.64,3.64,0,0,0,77,54.92a2.31,2.31,0,0,0-1.11-2.42A21.19,21.19,0,0,0,73,50.75a2,2,0,0,1-1.25-2.41l.25.78c.24.74.92,1,1.5,1.27.94.49,1.91.92,2.83,1.44,2,1.14,2.07,2.78.91,4.56-.51.78-1,1.59-1.48,2.39-.18.3-.18.48.27.56,1.65.3,3.28.77,4.94.95A25,25,0,0,0,85,60.23c2.54-.13,4.92-1,7.37-1.56a11,11,0,0,1,4.35-.26.83.83,0,0,0,.3,0c-.09-.79-.17-1.55-.25-2.31s-.13-1.29-.19-1.93a15.72,15.72,0,0,0-1.52-6.28c-.19-.33-.42-.63-.67-1a3.86,3.86,0,0,1,1.42,1.26A7.37,7.37,0,0,1,97,51.25c.37,1.88.61,3.79.93,5.68a21.28,21.28,0,0,0,1.71,5.94,10.8,10.8,0,0,0,3.87,4.43c1.87,1.17,3.85,2.18,5.82,3.16,1.64.82,3.33,1.53,5,2.21,2.11.85,4.24,1.62,6.37,2.42,1,.38,2,.73,3.06,1.11A1.87,1.87,0,0,1,125,77.37l-1.68-.85-.08.12c.17.59.39,1.17.5,1.77.32,1.6.61,3.2.88,4.81.22,1.24.43,2.49.59,3.75.09.69.08,1.39.12,2.09a4.41,4.41,0,0,0,1,2.88,7.33,7.33,0,0,0,.65.6A21.41,21.41,0,0,1,130.53,97a3.65,3.65,0,0,0,1.24,1.14h1c0-.1,0-.22-.05-.29a1.21,1.21,0,0,1-.12-1.58,4.2,4.2,0,0,0,.46-1.12c.15-.67-.32-1.14-.66-1.64-.12-.18-.27-.33-.41-.51l-.83,1.09L131,94a1.92,1.92,0,0,0,.3-2.19A3.55,3.55,0,0,0,130,89.93a3.33,3.33,0,0,1-1.6-2.77c-.23-1.44-.36-2.89-.52-4.33a16.56,16.56,0,0,1-.18-2.53c0-1.22.26-2.43.34-3.65a2.69,2.69,0,0,0-.73-2,16.4,16.4,0,0,0-3.36-2.5c-2.12-1.47-4.26-2.93-6.28-4.53a29.36,29.36,0,0,1-6.89-7.88,9.37,9.37,0,0,1-1.16-3.53A5.79,5.79,0,0,1,110,53.3a12.87,12.87,0,0,0,.7,5.14c1.1-.29,2.11-.71,2.28-1.93a7.38,7.38,0,0,0-.15-2.19c-.11-.68.24-1.07.92-.93A3.46,3.46,0,0,1,115.84,55c1.69,2.51,3.3,5.08,5,7.63,1,1.55,2,3.12,3,4.65,1.39,2,2.81,4.07,4.28,6a37.14,37.14,0,0,0,2.6,3c.81.88,1.68,1.71,2.54,2.55a33.26,33.26,0,0,0,13.43,7.64,53.51,53.51,0,0,0,5.88,1.27,26.24,26.24,0,0,0,4.93.3,35.29,35.29,0,0,0,5.21-.63,29.09,29.09,0,0,0,7.79-2.67c1.2-.61,2.31-1.38,3.47-2.08a.45.45,0,0,0,.2-.21c.06-.27.07-.54.11-.8-.23,0-.48-.14-.67-.07-.62.23-1.22.5-1.82.77a35.36,35.36,0,0,1-6.62,2.39,30.34,30.34,0,0,1-4.6.88,36.16,36.16,0,0,1-5.1,0,21.46,21.46,0,0,1-8.74-2.5,26.12,26.12,0,0,1-5.88-4.09c-.67-.62-1.33-1.23-2-1.87a43.62,43.62,0,0,1-4.66-5.67,82.8,82.8,0,0,1-4.93-8.12c-1.11-2-2.18-4-3.29-6.07A57.59,57.59,0,0,0,120.61,49a36.71,36.71,0,0,0-4.22-4.51,24.32,24.32,0,0,0-11.7-5.65,31.37,31.37,0,0,0-4.32-.59c-2.47-.14-5-.26-7.42-.2a41.33,41.33,0,0,0-10.6,1.48,28.35,28.35,0,0,0-6.18,3A14.5,14.5,0,0,1,72,44.41a5.38,5.38,0,0,1-1.13.14,20.4,20.4,0,0,0-2.47.09Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M338.24,11.75h-1.66v4.69h-1V11.75h-1.67v-1h4.3Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M344.33,10.77v5.67h-1v-4l-1.87,2.89-1.86-2.89v4h-1V10.77h1.06l1.77,2.76,1.79-2.76Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M188.85,25.48V27.3a12.52,12.52,0,0,0-3.22-1.73,11.74,11.74,0,0,0-4.18-.69,12.54,12.54,0,0,0-4.87.94,11.78,11.78,0,0,0-6.42,6.41A12,12,0,0,0,176.58,48a12.54,12.54,0,0,0,4.87.93h.48a13.22,13.22,0,0,0,4.93-.92V41.52l0,0A6.75,6.75,0,0,1,184.58,43a7.36,7.36,0,0,1-2.65.47,8.05,8.05,0,0,1-1.11-.08h0a8.18,8.18,0,0,1-1.55-.39A6.25,6.25,0,0,1,177,41.54a6.34,6.34,0,0,1,0-9.26,7,7,0,0,1,2.24-1.42,7.26,7.26,0,0,1,2.66-.5,6.82,6.82,0,0,1,4.9,1.92,6.15,6.15,0,0,1,2,4.65v12h5.77V25.48Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M164.45,48.93,151.67,36.6V48.93H145.9V16.44h5.77V28.72l12.78-12.23h8.16L155.75,32.66l16.86,16.27Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M209.61,24.88a10.62,10.62,0,0,1,4.28.85,9.8,9.8,0,0,1,3.29,2.33,10.6,10.6,0,0,1,2.11,3.44,11.67,11.67,0,0,1,.74,4.2V48.93h-5.76V35.7a4.87,4.87,0,0,0-1.68-3.79,5.85,5.85,0,0,0-7.93,0A5,5,0,0,0,203,35.7V48.93h-5.77V25.52H203v1.74A11.33,11.33,0,0,1,206,25.55,9.65,9.65,0,0,1,209.61,24.88Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M287.75,25.52a10.47,10.47,0,0,1,3.87-.68v5.47a6.86,6.86,0,0,0-4.9,1.92,6.36,6.36,0,0,0-2,4.65v12h-5.76V25.48h5.76v1.78A12.8,12.8,0,0,1,287.75,25.52Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M304.67,24.88a13.12,13.12,0,0,1,4.94.94,12.69,12.69,0,0,1,4,2.58,11.92,11.92,0,0,1,2.71,3.83,11.56,11.56,0,0,1,0,9.36,12.14,12.14,0,0,1-2.71,3.83,13.16,13.16,0,0,1-18,0A12.33,12.33,0,0,1,293,41.59a11.66,11.66,0,0,1,0-9.36,12.1,12.1,0,0,1,2.72-3.83,12.58,12.58,0,0,1,4-2.58A13.06,13.06,0,0,1,304.67,24.88Zm0,5.48a6.86,6.86,0,0,0-4.91,1.92,6.34,6.34,0,0,0,0,9.26A6.25,6.25,0,0,0,302,43a7.47,7.47,0,0,0,2.67.47,7.35,7.35,0,0,0,2.64-.47,6.75,6.75,0,0,0,2.25-1.44,6.32,6.32,0,0,0,0-9.26A7.06,7.06,0,0,0,304.67,30.36Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M331.64,24.88a13.13,13.13,0,0,1,4.95.94,12.69,12.69,0,0,1,4,2.58,12.07,12.07,0,0,1,2.71,3.83,11.56,11.56,0,0,1,0,9.36,12.3,12.3,0,0,1-2.71,3.83,13.15,13.15,0,0,1-18,0,12.17,12.17,0,0,1-2.72-3.83,11.66,11.66,0,0,1,0-9.36,11.94,11.94,0,0,1,2.72-3.83,12.64,12.64,0,0,1,4-2.58A13.13,13.13,0,0,1,331.64,24.88Zm0,5.48a6.86,6.86,0,0,0-4.9,1.92A6.5,6.5,0,0,0,329,43a7.41,7.41,0,0,0,2.66.47,7.27,7.27,0,0,0,2.64-.47,6.69,6.69,0,0,0,2.26-1.44,6.32,6.32,0,0,0,0-9.26A7.06,7.06,0,0,0,331.64,30.36Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M270,25.48V27.3a12.52,12.52,0,0,0-3.22-1.73,11.74,11.74,0,0,0-4.18-.69,12.54,12.54,0,0,0-4.87.94,11.78,11.78,0,0,0-6.42,6.41A12,12,0,0,0,257.71,48a12.54,12.54,0,0,0,4.87.93h.49A13.2,13.2,0,0,0,268,48V41.52l0,0A6.75,6.75,0,0,1,265.71,43a7.35,7.35,0,0,1-2.64.47,8.09,8.09,0,0,1-1.12-.08h0A8.18,8.18,0,0,1,260.4,43a6.25,6.25,0,0,1-2.24-1.44,6.34,6.34,0,0,1,0-9.26,7,7,0,0,1,2.24-1.42,7.28,7.28,0,0,1,2.67-.5A6.82,6.82,0,0,1,268,32.28a6.15,6.15,0,0,1,2,4.65v12h5.77V25.48Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M242,25.48V27.3a12.52,12.52,0,0,0-3.22-1.73,10.31,10.31,0,0,0-2.09-.53,14.83,14.83,0,0,0-2.48-.2,12.09,12.09,0,0,0-4.78.93,11.37,11.37,0,0,0-3.74,2.58,11.78,11.78,0,0,0-2.43,3.84,12.57,12.57,0,0,0-.86,4.69v0A11.81,11.81,0,0,0,229.76,48a12.59,12.59,0,0,0,4.88.93h.58l.27,0A13,13,0,0,0,240,48V41.52l0,0A6.79,6.79,0,0,1,237.76,43a7.27,7.27,0,0,1-2.64.47,8.32,8.32,0,0,1-1.12-.08h0a8.18,8.18,0,0,1-1.55-.39,6.7,6.7,0,0,1-4.25-6.07,6.49,6.49,0,0,1,.47-2.43l.09-.19a6.46,6.46,0,0,1,1.46-2,6.9,6.9,0,0,1,2.23-1.42,7.32,7.32,0,0,1,2.67-.5,6.86,6.86,0,0,1,4.9,1.92,6.46,6.46,0,0,1,1.46,2l.09.19a6.4,6.4,0,0,1,.47,2.45v9.13a6.13,6.13,0,0,1-2,4.6,7.06,7.06,0,0,1-8.36,1.06l-4.18,3.92a13.06,13.06,0,0,0,16.62-1.1,11.94,11.94,0,0,0,2.72-3.83,11.31,11.31,0,0,0,1-4.65V25.48Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M152.6,68.77V70.3h-6.7V61.57h6.44v1.54h-4.72v2.21h3.95v1.49h-3.95v2Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M163.66,60.85v9.34h-1.74v-.41a3.94,3.94,0,0,1-1.95.52,3.48,3.48,0,0,1,0-7,4,4,0,0,1,1.95.51v-3Zm-1.74,7.31v-2.7a2.53,2.53,0,0,0-1.64-.57,1.93,1.93,0,0,0-2,1.93,1.89,1.89,0,0,0,2,1.92A2.5,2.5,0,0,0,161.92,68.16Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M174.65,63.48V70.2h-1.72v-.44a3.29,3.29,0,0,1-1.83.54c-2,0-2.87-.92-2.87-3.09V63.48H170v3.73c0,1,.5,1.54,1.46,1.54a2.25,2.25,0,0,0,1.52-.53V63.48Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M185.25,69a3.24,3.24,0,0,1-2.6,1.35,3.48,3.48,0,1,1,0-6.95,3.25,3.25,0,0,1,2.63,1.34l-1.12,1a1.81,1.81,0,0,0-1.51-.82,1.93,1.93,0,1,0,0,3.85,1.8,1.8,0,0,0,1.51-.83Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M196.28,63.48V70.2h-1.72v-.49a3.5,3.5,0,0,1-2,.59,3.48,3.48,0,0,1,0-7,4,4,0,0,1,2,.56v-.42Zm-1.72,2a2.61,2.61,0,0,0-1.66-.58,1.93,1.93,0,1,0,0,3.85,2.53,2.53,0,0,0,1.66-.57Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M203,64.9v2.38c0,1.2.2,1.55,1.07,1.55.29,0,.55,0,.79-.06v1.28a4,4,0,0,1-1.56.25,1.93,1.93,0,0,1-2-2.12V64.9h-1V63.48h1V60.87H203v2.61h1.88V64.9Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M209,61.84a1,1,0,0,1,1-1,1,1,0,1,1-1,1Zm.13,1.74h1.72V70.3h-1.72Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M222.6,66.83a3.69,3.69,0,1,1-3.68-3.48A3.58,3.58,0,0,1,222.6,66.83Zm-1.7,0a2,2,0,1,0-2,1.92A2,2,0,0,0,220.9,66.83Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M233.32,66.55V70.3H231.6V66.55c0-1-.51-1.55-1.46-1.55a2.24,2.24,0,0,0-1.49.53V70.3h-1.72V63.58h1.72V64a3.12,3.12,0,0,1,1.8-.55C232.42,63.45,233.32,64.37,233.32,66.55Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M246.83,63.11v3.11H251v1.53h-4.17V70.3h-1.72V61.57h6.57v1.54Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M262.8,66.83a3.68,3.68,0,1,1-3.68-3.48A3.58,3.58,0,0,1,262.8,66.83Zm-1.69,0a2,2,0,1,0-2,1.92A2,2,0,0,0,261.11,66.83Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M273.49,63.48V70.2h-1.72v-.44a3.3,3.3,0,0,1-1.84.54c-2,0-2.87-.92-2.87-3.09V63.48h1.72v3.73c0,1,.51,1.54,1.46,1.54a2.29,2.29,0,0,0,1.53-.53V63.48Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M284.53,66.55V70.3h-1.72V66.55c0-1-.51-1.55-1.46-1.55a2.24,2.24,0,0,0-1.49.53V70.3h-1.72V63.58h1.72V64a3.12,3.12,0,0,1,1.8-.55C283.63,63.45,284.53,64.37,284.53,66.55Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M295.9,60.85v9.34h-1.73v-.41a4,4,0,0,1-2,.52,3.48,3.48,0,0,1,0-7,4.08,4.08,0,0,1,2,.51v-3Zm-1.73,7.31v-2.7a2.53,2.53,0,0,0-1.65-.57,1.93,1.93,0,0,0-2,1.93,1.89,1.89,0,0,0,2,1.92A2.53,2.53,0,0,0,294.17,68.16Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M307.29,63.48V70.2h-1.72v-.49a3.55,3.55,0,0,1-2,.59,3.48,3.48,0,0,1,0-7,4,4,0,0,1,2,.56v-.42Zm-1.72,2a2.63,2.63,0,0,0-1.66-.58,1.93,1.93,0,1,0,0,3.85,2.53,2.53,0,0,0,1.66-.57Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M314,64.9v2.38c0,1.2.2,1.55,1.06,1.55.3,0,.56,0,.8-.06v1.28a4.14,4.14,0,0,1-1.56.25,1.93,1.93,0,0,1-2-2.12V64.9h-1V63.48h1V60.87H314v2.61h1.88V64.9Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M320,61.84a1,1,0,0,1,1-1,1,1,0,1,1-1,1Zm.14,1.74h1.72V70.3h-1.72Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M333.6,66.83a3.68,3.68,0,1,1-3.67-3.48A3.57,3.57,0,0,1,333.6,66.83Zm-1.69,0a2,2,0,1,0-2,1.92A2,2,0,0,0,331.91,66.83Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M344.33,66.55V70.3h-1.72V66.55c0-1-.51-1.55-1.47-1.55a2.21,2.21,0,0,0-1.48.53V70.3h-1.72V63.58h1.72V64a3.06,3.06,0,0,1,1.79-.55C343.42,63.45,344.33,64.37,344.33,66.55Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M186.56,85.66V87.2h-6.72V78.44h6.46V80h-4.73V82.2h4v1.49h-4v2Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M194.55,77.83V87.2h-1.74v-.41a4,4,0,0,1-2,.52,3.49,3.49,0,0,1,0-7,4.08,4.08,0,0,1,2,.51v-3Zm-1.74,7.33V82.45a2.53,2.53,0,0,0-1.65-.57,1.93,1.93,0,0,0-2,1.94,1.89,1.89,0,0,0,2,1.92A2.51,2.51,0,0,0,192.81,85.16Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M202.48,80.45V87.2h-1.73v-.45a3.19,3.19,0,0,1-1.83.55c-2,0-2.89-.92-2.89-3.11V80.45h1.73v3.74c0,1,.51,1.55,1.47,1.55a2.25,2.25,0,0,0,1.52-.53V80.45Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M210,85.94a3.25,3.25,0,0,1-2.61,1.36,3.49,3.49,0,1,1,0-7A3.27,3.27,0,0,1,210,81.67l-1.12,1a1.84,1.84,0,0,0-1.52-.82,1.93,1.93,0,1,0,0,3.86,1.83,1.83,0,0,0,1.52-.83Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M218,80.45V87.2h-1.73v-.5a3.56,3.56,0,0,1-2,.6,3.49,3.49,0,0,1,0-7,4,4,0,0,1,2,.55v-.42Zm-1.73,2a2.58,2.58,0,0,0-1.67-.58,1.93,1.93,0,1,0,0,3.86,2.55,2.55,0,0,0,1.67-.57Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M221.64,81.88v2.39c0,1.2.2,1.55,1.07,1.55.3,0,.56,0,.8-.06v1.29a4.42,4.42,0,0,1-1.57.25,2,2,0,0,1-2-2.13V81.88h-1V80.45h1V77.83h1.74v2.62h1.89v1.43Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M224.55,78.71a1,1,0,0,1,1-1,1,1,0,0,1,0,2A1,1,0,0,1,224.55,78.71Zm.14,1.74h1.72V87.2h-1.72Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M235.06,83.82a3.7,3.7,0,1,1-3.69-3.49A3.59,3.59,0,0,1,235.06,83.82Zm-1.7,0a2,2,0,1,0-2,1.92A2,2,0,0,0,233.36,83.82Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M242.72,83.43V87.2H241V83.43c0-1-.51-1.55-1.47-1.55a2.19,2.19,0,0,0-1.49.54V87.2h-1.72V80.45H238v.42a3.19,3.19,0,0,1,1.8-.54C241.81,80.33,242.72,81.25,242.72,83.43Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M255.74,83.31a16.43,16.43,0,0,1-1.33,2l1.05,1-1,1-1-1a3.73,3.73,0,0,1-2.32,1c-2,0-3.3-1-3.3-2.55a2.63,2.63,0,0,1,1.83-2.35,2.33,2.33,0,0,1-.77-1.69,2.49,2.49,0,0,1,5-.18A2.68,2.68,0,0,1,252,82.92l1.5,1.43a9.57,9.57,0,0,0,1-1.44Zm-3.19,2.06-2-1.91c-.71.28-1,.72-1,1.23s.6,1.21,1.66,1.21A2.09,2.09,0,0,0,252.55,85.37Zm-2.22-4.61a1.78,1.78,0,0,0,.78,1.26c.55-.18,1.3-.57,1.3-1.27a1.05,1.05,0,0,0-1.06-1.15A1.09,1.09,0,0,0,250.33,80.76Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M267.31,78.44h1.94l-4.09,8.76h-.82l-4.08-8.76h1.93l2.56,5.71Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M270,78.71a1,1,0,1,1,1,1A1,1,0,0,1,270,78.71Zm.14,1.74h1.72V87.2h-1.72Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M273.77,85.37a5.39,5.39,0,0,0,2.31.55c.8,0,1.11-.3,1.11-.65s-.39-.56-1.43-.78c-1.45-.32-2.51-.8-2.51-2.1s1-2.06,2.57-2.06a7,7,0,0,1,2.64.54l-.58,1.27a6.14,6.14,0,0,0-2.09-.43c-.66,0-1,.23-1,.59s.41.55,1.49.77c1.57.33,2.47.87,2.47,2.1s-1,2.13-2.7,2.13a6,6,0,0,1-2.92-.65Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M286.74,80.45V87.2H285v-.5a3.56,3.56,0,0,1-2,.6,3.49,3.49,0,0,1,0-7,4.06,4.06,0,0,1,2,.55v-.42Zm-1.72,2a2.6,2.6,0,0,0-1.67-.58,1.93,1.93,0,1,0,0,3.86,2.57,2.57,0,0,0,1.67-.57Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M299,84.63c0,1.69-1.35,2.68-3.39,2.68a6.84,6.84,0,0,1-3.64-.83l.65-1.38a6.21,6.21,0,0,0,3.06.67c.95,0,1.52-.35,1.52-1s-.58-.86-1.86-1.16c-1.8-.41-3.25-.92-3.25-2.65,0-1.54,1.23-2.63,3.23-2.63a8.58,8.58,0,0,1,3.35.71L298,80.47a7.55,7.55,0,0,0-2.67-.59c-.9,0-1.39.4-1.39,1s.62.88,1.94,1.18C297.75,82.43,299,83,299,84.63Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M301.73,84.32a1.86,1.86,0,0,0,1.93,1.5A2.18,2.18,0,0,0,305.4,85l1.1.91a3.71,3.71,0,0,1-3,1.4,3.49,3.49,0,0,1,0-7c2.07,0,3.28,1.5,3.28,3.6,0,.14,0,.27,0,.39Zm0-1.11h3.34a1.48,1.48,0,0,0-1.62-1.5A1.77,1.77,0,0,0,301.74,83.21Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M309.71,81.4a2.53,2.53,0,0,1,2.12-1.07,1.23,1.23,0,0,1,.42.07v1.88a4.86,4.86,0,0,0-.83-.1,1.61,1.61,0,0,0-1.71,1.76V87.2H308V80.45h1.74Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M320.09,80.45l-3.22,6.75H316l-3.24-6.75h1.82l1.84,3.83,1.82-3.83Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M321,78.71a1,1,0,1,1,1,1A1,1,0,0,1,321,78.71Zm.14,1.74h1.72V87.2h-1.72Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M330.42,85.94a3.25,3.25,0,0,1-2.61,1.36,3.49,3.49,0,1,1,0-7,3.27,3.27,0,0,1,2.64,1.34l-1.12,1a1.84,1.84,0,0,0-1.52-.82,1.93,1.93,0,1,0,0,3.86,1.83,1.83,0,0,0,1.52-.83Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M332.83,84.32a1.87,1.87,0,0,0,1.93,1.5A2.17,2.17,0,0,0,336.5,85l1.1.91a3.69,3.69,0,0,1-3,1.4,3.49,3.49,0,0,1,0-7c2.07,0,3.28,1.5,3.28,3.6,0,.14,0,.27,0,.39Zm0-1.11h3.34a1.5,1.5,0,0,0-1.63-1.5A1.75,1.75,0,0,0,332.85,83.21Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M339.35,85.37a5.36,5.36,0,0,0,2.31.55c.79,0,1.1-.3,1.1-.65s-.38-.56-1.43-.78c-1.45-.32-2.51-.8-2.51-2.1s1-2.06,2.58-2.06a6.93,6.93,0,0,1,2.63.54l-.57,1.27a6.25,6.25,0,0,0-2.1-.43c-.66,0-1,.23-1,.59s.41.55,1.49.77c1.57.33,2.48.87,2.48,2.1s-1,2.13-2.71,2.13a6,6,0,0,1-2.92-.65Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPls1);
export default __webpack_public_path__ + "static/media/pls1.84352b6f935a76bd64e0065383265fdd.svg";
export { ForwardRef as ReactComponent };